"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.443 13.039h-1.02V11.4v-.127-.183V9.3h1.02v3.739zM12.443 14.7h-1.02v-.982h1.02v.982z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12a6 6 0 1112 0 6 6 0 01-12 0zm6 5.1a5.1 5.1 0 110-10.2 5.1 5.1 0 010 10.2z" })), "AlertOutline");
//# sourceMappingURL=AlertOutline.js.map